import Box from "component/layoutComponents/Box";
import styled from "styled-components";
import { IconButton } from "@mui/material";
import { COMMENT_INPUT_HEIGHT } from "../constants";

export const ICON_BUTTON_SIZE = 30;

export const StyledCommentInput = styled(Box)(({ theme }) => `
  border-radius: 4px;
  border: 1px solid ${theme.uptimeColors.grayScales.gray};
  
  & > *:first-child {
    border-radius: 24px;
  }
`);

export const StyledListAttachment = styled(Box)(({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.uptimeSpace[6]}px;
  flex-wrap: wrap;
  padding: 0 ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[6]}px;
`);

export const StyledAttachment = styled(Box)<{ isMobile?: boolean }>(({ theme, isMobile }) => `
  display: flex;
  align-items: center;
  width: ${isMobile ? '100%' : '30%'};
  height: ${COMMENT_INPUT_HEIGHT}px;
  gap: ${theme.uptimeSpace[4]}px;
  background-color: ${theme.uptimeColors.grayScales.white};
  padding: ${theme.uptimeSpace[3]}px ${theme.uptimeSpace[5]}px;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid ${theme.uptimeColors.grayScales.grayishBackground};

  button {
    margin-left: auto;
    &:hover {
      color: ${theme.uptimeColors.grayScales.black};
    }
  }
`);

export const StyledAttachmentName = styled(Box)(({ theme }) => `
  word-break: break-all;
  cursor: default;
`);

export const StyledIconButton = styled(IconButton)<{isOpenAttachment?: boolean}>(({ theme, isOpenAttachment }) => `
  &.MuiIconButton-root {
    width: ${ICON_BUTTON_SIZE}px;
    height: ${ICON_BUTTON_SIZE}px;
    border-radius: 4px;
    background-color: ${ isOpenAttachment ? theme.uptimeColors.grayScales.white : theme.uptimeColors.grayScales.lightGray};
    
    &.Mui-disabled {
      background-color: ${theme.uptimeColors.grayScales.lightGray};
    }
    
    & > svg {
      width: 20px;
      height: 20px;
      color: ${ isOpenAttachment ? theme.uptimeColors.mainTheme.primary : theme.uptimeColors.grayScales.darkerGray};
    }
  }
`);
